import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/dist/query'
import { splitReducer } from '@splitsoftware/splitio-redux'

import { legalDescriptionReducer } from './legalDescriptionSlice'
import { generalReducer } from '@/client/generalSlice'
import { workQueuesReducer } from '@/client/workQueuesSlice'
import { errorBondaryReducer } from '@/components/ErrorBoundary/errorBondarySlice'
import { addTradelineReducer } from '@/features/AddTradeline/addTradelineSlice'
import { kickBackReducer } from '@/features/DealKickBack/kickBackSlice'
import { documentRequestReducer } from '@/features/DocumentRequest/documentRequestSlice'
import { fileManagerReducer } from '@/features/FileManager/fileManagerSlice'
import { taskTemplateReducer } from '@/features/Tasks/taskTemplateSlice'
import { CalculationInputsReducer } from '@/features/UnlockScenarioCalculator/UnlockCalculatorSlice'
import applicationReducer from '@/features/application/applicationSlice'
import { documentViewerReducer } from '@/features/DocumentsViewer/documentViewerSlice'
import { graphqlApi } from '@/graphql'
import { baseApi } from '@/services'
import { s3Api } from '@/services/s3'

const store = configureStore({
  reducer: {
    // State slices
    application: applicationReducer,

    general: generalReducer,

    splitio: splitReducer,

    taskTemplate: taskTemplateReducer,

    fileManager: fileManagerReducer,

    workQueues: workQueuesReducer,

    legalDescription: legalDescriptionReducer,

    CalculationInputs: CalculationInputsReducer,

    errorBondary: errorBondaryReducer,

    documentRequest: documentRequestReducer,

    addTradeline: addTradelineReducer,

    kickback: kickBackReducer,

    documentViewer: documentViewerReducer,

    // RTK Query slices
    [baseApi.reducerPath]: baseApi.reducer,
    [s3Api.reducerPath]: s3Api.reducer,
    [graphqlApi.reducerPath]: graphqlApi.reducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware, s3Api.middleware, graphqlApi.middleware),
})

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
